const mapping = {
  '/experiences/belgium/': '/locations/belgium/',
  '/experiences/belgium/antwerp/': '/locations/belgium/antwerp/',
  '/experiences/belgium/antwerp/tours/': '/locations/belgium/antwerp/tours/',
  '/experiences/belgium/bruges/': '/locations/belgium/bruges/',
  '/experiences/belgium/bruges/tours/': '/locations/belgium/bruges/tours/',
  '/experiences/belgium/brussels/': '/locations/belgium/brussels/',
  '/experiences/belgium/brussels/tours/': '/locations/belgium/brussels/tours/',
  '/experiences/cambodia/': '/locations/cambodia/things-to-do/',
  '/experiences/cambodia/phnom-penh/': '/locations/cambodia/phnom-penh/',
  '/experiences/cambodia/siem-reap/':
    '/locations/cambodia/siem-reap/things-to-do/',
  '/experiences/cambodia/siem-reap/tours/': '/locations/cambodia/siem-reap/',
  '/experiences/cambodia/tours/': '/locations/cambodia/',
  '/experiences/czech-republic/': '/locations/czech-republic/',
  '/experiences/czech-republic/prague/': '/locations/czech-republic/prague/',
  '/experiences/czech-republic/prague/tours/':
    '/locations/czech-republic/prague/tours/',
  '/experiences/england/': '/locations/england/',
  '/experiences/england/london/': '/locations/england/london/',
  '/experiences/france/': '/locations/france/',
  '/experiences/france/paris/': '/locations/france/paris/',
  '/experiences/france/paris/tours/': '/locations/france/paris/tours/',
  '/experiences/france/paris/tours/bike/':
    '/locations/france/paris/tours/bike-tours/',
  '/experiences/france/paris/tours/food-tours/':
    '/locations/france/paris/tours/food-tours/',
  '/experiences/france/paris/tours/walking/':
    '/locations/france/paris/tours/walking-tours/',
  '/experiences/france/tours/': '/locations/france/tours/',
  '/experiences/germany/': '/locations/germany/',
  '/experiences/germany/berlin/': '/locations/germany/berlin/',
  '/experiences/germany/berlin/familiy-friendly/':
    '/locations/germany/berlin/things-to-do-with-toddlers/',
  '/experiences/germany/berlin/tours/': '/locations/germany/berlin/tours/',
  '/experiences/germany/berlin/tours/bike/':
    '/locations/germany/berlin/tours/bike-tours/',
  '/experiences/germany/berlin/tours/food-tours/':
    '/locations/germany/berlin/tours/food-tours/',
  '/experiences/germany/berlin/tours/walking/':
    '/locations/germany/berlin/tours/walking-tours/',
  '/experiences/germany/munich/': '/locations/germany/munich/',
  '/experiences/germany/munich/tours/': '/locations/germany/munich/tours/',
  '/experiences/germany/tours/': '/locations/germany/tours/',
  '/experiences/greece/': '/locations/greece/',
  '/experiences/greece/athens/': '/locations/greece/athens/',
  '/experiences/greece/athens/tours/': '/locations/greece/athens/tours/',
  '/experiences/hong-kong/': '/locations/hong-kong/things-to-do/',
  '/experiences/hong-kong/tours/': '/locations/hong-kong/',
  '/experiences/hungary/': '/locations/hungary/',
  '/experiences/hungary/budapest/': '/locations/hungary/budapest/',
  '/experiences/hungary/budapest/tours/': '/locations/hungary/budapest/tours/',
  '/experiences/india/': '/locations/india/',
  '/experiences/india/kochi/': '/locations/india/kochi/things-to-do/',
  '/experiences/india/kochi/tours/': '/locations/india/kochi/',
  '/experiences/india/mumbai/tours/': '/locations/india/mumbai/',
  '/experiences/india/mumbai/': '/locations/india/mumbai/things-to-do/',
  '/experiences/india/tours/': '/locations/india/private-tours-india/',
  '/experiences/indonesia/': '/locations/indonesia/things-to-do/',
  '/experiences/indonesia/bali/': '/locations/indonesia/bali/things-to-do/',
  '/experiences/indonesia/bali/tours/': '/locations/indonesia/bali/',
  '/experiences/indonesia/denpasar/':
    '/locations/indonesia/denpasar/things-to-do/',
  '/experiences/indonesia/denpasar/tours/': '/locations/indonesia/denpasar/',
  '/experiences/indonesia/jakarta/':
    '/locations/indonesia/jakarta/things-to-do/',
  '/experiences/indonesia/tours/': '/locations/indonesia/',
  '/experiences/indonesia/yogyakarta/':
    '/locations/indonesia/yogyakarta/things-to-do/',
  '/experiences/italy/': '/locations/italy/',
  '/experiences/italy/florence/': '/locations/italy/florence/',
  '/experiences/italy/florence/tours/': '/locations/italy/florence/tours/',
  '/experiences/italy/milan/': '/locations/italy/milan/',
  '/experiences/italy/milan/tours/': '/locations/italy/milan/tours/',
  '/experiences/italy/rome/': '/locations/italy/rome/',
  '/experiences/italy/rome/family-friendly/':
    '/locations/italy/rome/things-to-do-with-kids/',
  '/experiences/italy/rome/tours/': '/locations/italy/rome/tours/',
  '/experiences/italy/rome/tours/bike/':
    '/locations/italy/rome/tours/bike-tours/',
  '/experiences/italy/rome/tours/day-trips/':
    '/locations/italy/rome/tours/day-trip-tours/',
  '/experiences/italy/rome/tours/food-tours/':
    '/locations/italy/rome/tours/food-tours/',
  '/experiences/italy/rome/tours/walking/':
    '/locations/italy/rome/tours/walking-tours/',
  '/experiences/italy/tours/': '/locations/italy/tours/',
  '/experiences/malaysia/': '/locations/malaysia/activities/',
  '/experiences/malaysia/kuala-lumpur/':
    '/locations/malaysia/kuala-lumpur/unusual-things-to-do/',
  '/experiences/malaysia/kuala-lumpur/family-friendly/':
    '/locations/malaysia/kuala-lumpur/things-to-do-with-children/',
  '/experiences/malaysia/kuala-lumpur/tours/':
    '/locations/malaysia/kuala-lumpur/',
  '/experiences/malaysia/kuala-lumpur/tours/bike/':
    '/locations/malaysia/kuala-lumpur/tours/bike-tours/',
  '/experiences/malaysia/kuala-lumpur/tours/day-trip/':
    '/locations/malaysia/kuala-lumpur/tours/day-trip-tours/',
  '/experiences/malaysia/kuala-lumpur/tours/food-tours/':
    '/locations/malaysia/kuala-lumpur/tours/food-tours/',
  '/experiences/malaysia/kuala-lumpur/tours/walking/':
    '/locations/malaysia/kuala-lumpur/tours/walking-tours/',
  '/experiences/malaysia/penang/': '/locations/malaysia/penang/activities/',
  '/experiences/malaysia/penang/tours/': '/locations/malaysia/penang/',
  '/experiences/malaysia/tours/': '/locations/malaysia/',
  '/experiences/morocco/': '/locations/morocco/',
  '/experiences/morocco/marrakech/': '/locations/morocco/marrakech/',
  '/experiences/morocco/marrakech/tours/':
    '/locations/morocco/marrakech/tours/',
  '/experiences/nepal/': '/locations/nepal/things-to-do/',
  '/experiences/nepal/bhaktapur/': '/locations/nepal/bhaktapur/things-to-do/',
  '/experiences/nepal/kathmandu/': '/locations/nepal/kathmandu/things-to-do/',
  '/experiences/nepal/tours/': '/locations/nepal/',
  '/experiences/philippines/': '/locations/philippines/things-to-do/',
  '/experiences/philippines/cebu/': '/locations/philippines/cebu/things-to-do/',
  '/experiences/philippines/cebu/tours/': '/locations/philippines/cebu/',
  '/experiences/philippines/manila/':
    '/locations/philippines/manila/things-to-do/',
  '/experiences/philippines/manila/tours/': '/locations/philippines/manila/',
  '/experiences/philippines/palawan/':
    '/locations/philippines/palawan/things-to-do/',
  '/experiences/philippines/palawan/tours/': '/locations/philippines/palawan/',
  '/experiences/portugal/': '/locations/portugal/',
  '/experiences/portugal/lisbon/': '/locations/portugal/lisbon/',
  '/experiences/portugal/lisbon/family-friendly/':
    '/locations/portugal/lisbon/things-to-do-with-toddlers/',
  '/experiences/portugal/lisbon/food-tours/':
    '/locations/portugal/lisbon/tours/food-tours/',
  '/experiences/portugal/lisbon/tours/': '/locations/portugal/lisbon/tours/',
  '/experiences/portugal/lisbon/tours/bike/':
    '/locations/portugal/lisbon/tours/bike-tours/',
  '/experiences/portugal/lisbon/tours/day-trips/':
    '/locations/portugal/lisbon/tours/day-trip-tours/',
  '/experiences/portugal/lisbon/tours/walking/':
    '/locations/portugal/lisbon/tours/walking-tours/',
  '/experiences/portugal/porto/': '/locations/portugal/porto/',
  '/experiences/portugal/porto/tours/': '/locations/portugal/porto/tours/',
  '/experiences/portugal/tours/': '/locations/portugal/tours/',
  '/experiences/singapore/': '/locations/singapore/things-to-do/',
  '/experiences/singapore/tours/': '/locations/singapore/',
  '/experiences/spain/': '/locations/spain/',
  '/experiences/spain/barcelona/': '/locations/spain/barcelona/',
  '/experiences/spain/barcelona/tours/': '/locations/spain/barcelona/tours/',
  '/experiences/spain/barcelona/tours/bike/':
    '/locations/spain/barcelona/tours/bike-tours/',
  '/experiences/spain/barcelona/tours/day-trips/':
    '/locations/spain/barcelona/tours/day-trip-tours/',
  '/experiences/spain/barcelona/tours/food-tours/':
    '/locations/spain/barcelona/tours/food-tours/',
  '/experiences/spain/barcelona/tours/walking/':
    '/locations/spain/barcelona/tours/walking-tours/',
  '/experiences/spain/madrid/': '/locations/spain/madrid/',
  '/experiences/spain/madrid/tours/': '/locations/spain/madrid/tours/',
  '/experiences/spain/seville/': '/locations/spain/seville/',
  '/experiences/spain/seville/tours/': '/locations/spain/seville/tours/',
  '/experiences/spain/tours/': '/locations/spain/tours/',
  '/experiences/spain/valencia/': '/locations/spain/valencia/',
  '/experiences/spain/valencia/tours/': '/locations/spain/valencia/tours/',
  '/experiences/sri-lanka/': '/locations/sri-lanka/things-to-do/',
  '/experiences/sri-lanka/colombo/':
    '/locations/sri-lanka/colombo/things-to-do/',
  '/experiences/sri-lanka/colombo/tours/': '/locations/sri-lanka/colombo/',
  '/experiences/sri-lanka/galle/': '/locations/sri-lanka/galle/things-to-do/',
  '/experiences/sri-lanka/galle/tours/': '/locations/sri-lanka/galle/',
  '/experiences/sri-lanka/kandy/': '/locations/sri-lanka/kandy/things-to-do/',
  '/experiences/sri-lanka/kandy/tours/': '/locations/sri-lanka/kandy/',
  '/experiences/sri-lanka/tours/tours/': '/locations/sri-lanka/',
  '/experiences/taiwan/': '/locations/taiwan/things-to-do/',
  '/experiences/taiwan/taipei/': '/locations/taiwan/taipei/things-to-do/',
  '/experiences/taiwan/taipei/tours/': '/locations/taiwan/taipei/',
  '/experiences/thailand/': '/locations/thailand/things-to-do/',
  '/experiences/thailand/bangkok/': '/locations/thailand/bangkok/things-to-do/',
  '/experiences/thailand/bangkok/family-friendly/':
    '/locations/thailand/bangkok/things-to-do-with-kids/',
  '/experiences/thailand/bangkok/tours/': '/locations/thailand/bangkok/',
  '/experiences/thailand/bangkok/tours/bike/':
    '/locations/thailand/bangkok/tours/bike-tours/',
  '/experiences/thailand/bangkok/tours/walking/':
    '/locations/thailand/bangkok/tours/walking-tours/',
  '/experiences/thailand/chiang-mai/':
    '/locations/thailand/chiang-mai/activities/',
  '/experiences/thailand/chiang-mai/tours/': '/locations/thailand/chiang-mai/',
  '/experiences/thailand/tours/': '/locations/thailand/',
  '/experiences/the-netherlands/': '/locations/the-netherlands/',
  '/experiences/the-netherlands/amsterdam/':
    '/locations/the-netherlands/amsterdam/',
  '/experiences/the-netherlands/amsterdam/family-friendly/':
    '/locations/the-netherlands/amsterdam/things-to-do-with-children/',
  '/experiences/the-netherlands/amsterdam/tours/':
    '/locations/the-netherlands/amsterdam/tours/walking-tours/',
  '/experiences/the-netherlands/amsterdam/tours/bike/':
    '/locations/the-netherlands/amsterdam/tours/bike-tours/',
  '/experiences/the-netherlands/amsterdam/tours/day-trip/':
    '/locations/the-netherlands/amsterdam/tours/day-trip-tours/',
  '/experiences/the-netherlands/eindhoven/':
    '/locations/the-netherlands/eindhoven/',
  '/experiences/the-netherlands/eindhoven/tours/':
    '/locations/the-netherlands/eindhoven/tours/',
  '/experiences/the-netherlands/tours/': '/locations/the-netherlands/tours/',
  '/experiences/turkey/': '/locations/turkey/',
  '/experiences/turkey/istanbul/': '/locations/turkey/istanbul/',
  '/experiences/turkey/istanbul/tours/': '/locations/turkey/istanbul/tours/',
  '/experiences/united-arab-emirates/': '/locations/united-arab-emirates/',
  '/experiences/united-arab-emirates/abu-dhabi/':
    '/locations/united-arab-emirates/abu-dhabi/',
  '/experiences/united-arab-emirates/dubai/':
    '/locations/united-arab-emirates/dubai/',
  '/experiences/united-arab-emirates/dubai/tours/':
    '/locations/united-arab-emirates/dubai/tours/',
  '/experiences/vietnam/': '/locations/vietnam/things-to-do/',
  '/experiences/vietnam/hanoi/': '/locations/vietnam/hanoi/things-to-do/',
  '/experiences/vietnam/hanoi/tours/': '/locations/vietnam/hanoi/',
  '/experiences/vietnam/ho-chi-minh-city/':
    '/locations/vietnam/ho-chi-minh-city/things-to-do/',
  '/experiences/vietnam/ho-chi-minh-city/tours/':
    '/locations/vietnam/ho-chi-minh-city/',
  '/experiences/vietnam/hoi-an/': '/locations/vietnam/hoi-an/things-to-do/',
  '/experiences/vietnam/hoi-an/tours/': '/locations/vietnam/hoi-an/',
  '/experiences/vietnam/hue/tours/': '/locations/vietnam/hue/',
  '/experiences/vietnam/nha-trang/tours/': '/locations/vietnam/nha-trang/',
  '/experiences/vietnam/tours/': '/locations/vietnam/',
  '/experiences/thailand/bangkok/tours/day-trips/':
    '/locations/thailand/bangkok/tours/day-trip-tours/',
};

const map = (path) => {
  const mappedValue = mapping[path];
  if (mappedValue) {
    return mappedValue;
  }

  return path;
};

export default { map };
